export type CsvCell = string | number | null | undefined;

const escapeCell = (v: CsvCell): string => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** RFC 4180 rows. Numbers stay raw (no thousands separator) so a spreadsheet reads them as numbers. */
export const toCsv = (header: string[], rows: CsvCell[][]): string =>
  [header, ...rows].map((r) => r.map(escapeCell).join(',')).join('\r\n');

/** The BOM makes Excel open the file as UTF-8 instead of the system code page. */
export const downloadCsv = (filename: string, csv: string): void => {
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
